<template>
  <div class="iframe-container">
    <div v-if="templateHtml && showWatermark" class="watermark watermark--top">
      <WedNicelyLogo />
    </div>
    <iframe
      class="iframe-container__iframe"
      :srcdoc.prop="templateHtml"
    ></iframe>
    <div
      v-if="templateHtml && showWatermark"
      class="watermark watermark--bottom"
    >
      <WedNicelyLogo />
    </div>
  </div>
</template>

<script>
import WedNicelyLogo from "@/assets/logo/wednicely_logo.svg?inline";

export default {
  components: {
    WedNicelyLogo
  },

  props: {
    templateHtml: {
      type: String,
      required: true
    },

    showWatermark: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";

.iframe-container {
  position: relative;
  padding-top: 177.7777778%; /* 16:9 aspect ration */
  margin-bottom: 80px;
}

.iframe-container__iframe {
  position: absolute;
  border: 0;
  height: 200%;
  width: 200%;
  top: 0;
  left: 0;
  transform: scale(0.5);
  transform-origin: top left;
}

.watermark {
  position: absolute;
  z-index: 2;
  width: 150px;
  background-color: #333;
  color: #fff;
  opacity: 0.5;
  padding: 10px;
}

.watermark--top {
  top: 0;
  right: 10%;
}

.watermark--bottom {
  bottom: 0;
  left: 10%;
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .iframe-container {
    padding-top: 56.25%;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: initial;
  }

  .iframe-container__iframe {
    height: 100%;
    width: 100%;
    transform: none;
  }
}
</style>
